import DiscoveryPreview from './DiscoveryPreview';
// Existing exports retained so every listing surface keeps its data and navigation contracts.
export const BusinessCard = ({business, variant}) => <DiscoveryPreview business={business} list />;
export const BusinessCardCompact = ({business}) => <div className="dq-shared-compact"><DiscoveryPreview business={business}/></div>;
export const BusinessCardImmersive = ({business}) => <DiscoveryPreview business={business} list />;
export default BusinessCard;
